module.exports = __webpack_public_path__ + "img/nostromo 2.8a264e02.jpeg";